// ─────────────────────────────────────────────────────────────────────────────
// Canborsa DEX — constants
// TODO: Fill contract addresses after devtools inspection on canborsa.com
//       Network tab → filter eth_sendRawTransaction / eth_call while placing
//       a test trade to extract router address + position manager ABI.
// ─────────────────────────────────────────────────────────────────────────────

export const CANBORSA_CHAIN_ID = 42161; // Arbitrum One (primary)

// ── Contracts ─────────────────────────────────────────────────────────────────
// TODO: Replace null values after contract discovery
export const CANBORSA_CONTRACTS = {
  Router:          null, // main entry point for open/close orders
  PositionManager: null, // read open positions
  Oracle:          null, // on-chain price oracle (Chainlink or Pyth)
  Vault:           null, // collateral vault / fee receiver
};

// ── Tokens ────────────────────────────────────────────────────────────────────
// Native USDC on Arbitrum — same address as GMX, already known
export const CANBORSA_TOKENS = {
  USDC: { address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831', decimals: 6,  symbol: 'USDC' },
  USDT: { address: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9', decimals: 6,  symbol: 'USDT' },
  // USDCx: TODO — bridged Canton stablecoin, address unknown until discovered
};

// ── Markets ───────────────────────────────────────────────────────────────────
// Canborsa supports: crypto + tokenized equities + commodities + indices
// cgId  = CoinGecko id for live price feed (crypto only)
// rfId  = Refinitiv / Polygon.io ticker for RWA (TODO: wire up price source)
// TODO: Add on-chain market token addresses once discovered

export const CANBORSA_MARKETS = {
  // ── Crypto ──────────────────────────────────────────────────────────────────
  'BTC/USD': {
    symbol:         'BTC',
    category:       'crypto',
    cgId:           'bitcoin',
    rfId:           null,
    marketToken:    null, // TODO
    pricePrecision: 0,
    maxLeverage:    30,
    pythFeedId:     '0xe62df6c8b4a85fe1a67db44dc12de5db330f7ac66b72dc658afedf0f4a415b43',
  },
  'ETH/USD': {
    symbol:         'ETH',
    category:       'crypto',
    cgId:           'ethereum',
    rfId:           null,
    marketToken:    null, // TODO
    pricePrecision: 2,
    maxLeverage:    30,
    pythFeedId:     '0xff61491a931112ddf1bd8147cd1b641375f79f5825126d665480874634fd0ace',
  },
  // ── Tokenized equities ───────────────────────────────────────────────────────
  'AAPL/USD': {
    symbol:         'AAPL',
    category:       'equity',
    cgId:           null,
    rfId:           'AAPL',        // Polygon.io / Refinitiv ticker
    marketToken:    null,          // TODO
    pricePrecision: 2,
    maxLeverage:    10,
    pythFeedId:     null,          // TODO: check if Pyth has AAPL feed
  },
  'NVDA/USD': {
    symbol:         'NVDA',
    category:       'equity',
    cgId:           null,
    rfId:           'NVDA',
    marketToken:    null,
    pricePrecision: 2,
    maxLeverage:    10,
    pythFeedId:     null,
  },
  'TSLA/USD': {
    symbol:         'TSLA',
    category:       'equity',
    cgId:           null,
    rfId:           'TSLA',
    marketToken:    null,
    pricePrecision: 2,
    maxLeverage:    10,
    pythFeedId:     null,
  },
  // ── Commodities ──────────────────────────────────────────────────────────────
  'XAU/USD': {
    symbol:         'GOLD',
    category:       'commodity',
    cgId:           null,
    rfId:           'GC=F',        // gold futures ticker
    marketToken:    null,
    pricePrecision: 2,
    maxLeverage:    10,
    pythFeedId:     '0x765d2ba906dbc32ca17cc11f5310a89e9ee1f6420508c63861f2f8ba4ee34bb2', // XAU/USD on Pyth
  },
};

// Category display order in market selector
export const MARKET_CATEGORIES = ['crypto', 'equity', 'commodity'];

// ── Fee constants ─────────────────────────────────────────────────────────────
// TODO: Read actual execution fee from contract — using GMX fallback as placeholder
export const CANBORSA_EXECUTION_FEE_FALLBACK_WEI = '200000000000000'; // 0.0002 ETH
export const CANBORSA_MIN_POSITION_USD = 10; // TODO: confirm minimum from contract

// ── Collateral tokens users can choose ───────────────────────────────────────
export const COLLATERAL_OPTIONS = ['USDC', 'USDT'];
